import { Configuration, FetchAPI } from "../api";

export const defaultAPIConfig = (fetch?: FetchAPI) =>
  new Configuration({
    basePath: process.env.GATSBY_API_URL,
    fetchApi: fetch,
  });
